// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"5d3df2cf","160":"44a97613","208":"982d416f","293":"848fdb6d","516":"3219202d","519":"821a9d4c","917":"b034d8fa","946":"22b63a9b"}[chunkId] + ".chunk.js";
};